import React, { useEffect, useState } from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { trackLead } from './MetaPixel';
export function StickyCTA() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      // Show sticky CTA after scrolling 300px
      setIsVisible(window.scrollY > 300);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const handleCTA = () => {
    trackLead();
    const baseUrl = 'https://closerdigital.net/F/NLeon2';
    const utmParams = '?utm_source=facebook&utm_medium=cpc&utm_campaign={{campaign.name}}&utm_adset={{adset.name}}&utm_ad={{ad.name}}&utm_content={{ad.id}}&ref=alexa';
    window.location.href = baseUrl + utmParams;
  };
  if (!isVisible) return null;
  return <div className="fixed bottom-0 left-0 right-0 z-50 md:hidden" data-id="element-183">
      <div className="bg-gradient-to-r from-[#0D0D0D] via-[#1C1C1C] to-[#0D0D0D] border-t-2 border-[#D4AF37]/30 px-4 py-3 shadow-[0_-4px_20px_rgba(212,175,55,0.3)]" data-id="element-184">
        <button onClick={handleCTA} className="w-full group inline-flex items-center justify-center gap-2 px-6 py-3 bg-gradient-to-r from-[#FF4F75] to-[#D4AF37] rounded-full font-['Montserrat'] font-bold text-sm text-white transition-all duration-300 hover:scale-105 hover:shadow-[0_0_20px_rgba(212,175,55,0.5)]" data-id="element-185">
          <span data-id="element-186">Descubre Cómo Funciona</span>
          <ArrowRightIcon className="w-4 h-4 group-hover:translate-x-1 transition-transform duration-300" data-id="element-187" />
        </button>
      </div>
    </div>;
}